module.exports = require("mobx-react");